@if (canLoadPage ) {
  <p class="fs-24 kbBlueText software-request-title">{{'common.text_software_request_form_lable'|cxTranslate}}</p>
  <div class="mysoftTopHeader">{{'common.text_software_request_form_company_information_lable'|cxTranslate}}
  </div>
  <div class="bgColor">
    <form [formGroup]="companyInfo">
      <div class="formWrapperDiv">
        <div class="row col-12 px-0 mx-0">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
            <label for="3dcad">{{'common.text_software_request_form_company_lable'|cxTranslate}}
            </label>
            <div>
              <input formControlName="company" type="text"
                [placeholder]="'common.text_software_placeholder'|cxTranslate">
              </div>
              @if (companyInfo.controls.company.invalid && companyInfo.controls.company.touched ) {
                <div>
                  <span class="text_danger_show_acc">
                    {{'common.requestform_companyName_invalid'|cxTranslate}}
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="row col-12 px-0 mx-0">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="">{{'common.text_software_request_form_first_name_lable'|cxTranslate}}</label>
              <input formControlName="firstName" type="text"
                [placeholder]="'common.text_software_placeholder'|cxTranslate">
                @if (companyInfo.controls.firstName.invalid && companyInfo.controls.firstName.touched ) {
                  <div>
                    <span class="text_danger_show_acc">
                      {{'common.profile_firstName_invalid'|cxTranslate}}
                    </span>
                  </div>
                }
              </div>
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <label for="">{{'common.text_software_request_form_last_name_lable'|cxTranslate}}</label>
                <input formControlName="lastName" type="text"
                  [placeholder]="'common.text_software_placeholder'|cxTranslate">
                  @if (companyInfo.controls.lastName.invalid && companyInfo.controls.lastName.touched ) {
                    <div>
                      <span class="text_danger_show_acc">
                        {{'common.address_lastName_invalid'|cxTranslate}}
                      </span>
                    </div>
                  }
                </div>
              </div>
              <div class="row col-12 px-0 mx-0">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="3dcad">{{'common.text_software_request_form_postal_code_lable'|cxTranslate}}
                  </label>
                  <div>
                    <input formControlName="postalcode" type="text"
                      [placeholder]="'common.text_software_placeholder'|cxTranslate">
                      @if (companyInfo.controls.postalcode.invalid && companyInfo.controls.postalcode.touched ) {
                        <div
                          >
                          <span class="text_danger_show_acc">
                            {{'common.requestform_postalCode_invalid'|cxTranslate}}
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                  @if (getCountry$ | async; as country) {
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                      <label for="3dcad">{{'common.text_software_request_form_country_lable'|cxTranslate}}
                      </label>
                      <div class="form-group select-box">
                        <select formControlName="country">
                          <option value="null" [selected]="companyInfo.controls.country.value == null">
                          {{'common.form_select_empty'|cxTranslate}}</option>
                          @for (item of country.countriesWSList; track item) {
                            <option [value]="item.isocode">
                              {{item.name}}
                            </option>
                          }
                        </select>
                      </div>
                      @if (companyInfo.controls.country.invalid && companyInfo.controls.country.touched ) {
                        <div>
                          <span class="text_danger_show_acc">
                            {{'common.requestform_country_invalid'|cxTranslate}}
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="row col-12 px-0 mx-0">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.text_software_request_form_email_lable'|cxTranslate}}</label>
                    <div><input formControlName="email" type="email"></div>
                    @if (companyInfo.controls.email.invalid && companyInfo.controls.email.touched ) {
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.requestform_emailID_invalid'|cxTranslate}}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </form>
            <div class="captchaSection-padding">
              <form [formGroup]="captchaSection">
                <section class="recapctha-Section mt-4">
                  <div class="mb-2">
                    <input type="checkbox" formControlName="privacyTermsCheckBox">
                    <div class="kbBlueText">{{'common.text_software_search_type_code_i_accept_the'|cxTranslate}}
                      <u (click)="openPrivacyPopup()">
                        {{'common.text_software_request_form_conditions_lable_NA'|cxTranslate}}
                      </u>
                    </div>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 software-captcha">
                    <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)"
                    formControlName="recaptcha" name="recaptcha" required></re-captcha>
                    @if (captchaSection.controls.recaptcha.invalid && (captchaSection.controls.recaptcha.dirty || captchaSection.controls.recaptcha.touched)) {
                      <div class="invalid-feedback"
                        >
                      {{'common.register_captcha_invalid_msg'|cxTranslate}}</div>
                    }
                  </div>
                </section>
              </form>
              <section class="mt-4 pl-3">
                <div class="row mx-0 pl-0 col-1g-6 col-md-12 col-sm-12">
                    <button class="btn btn-primary col-lg-3
                 col-md-12 col-sm-12 mr-1 mb-sm-3 mb-3 mb-md-0 sw-request"
                    [disabled]="(captchaSection.controls.privacyTermsCheckBox.value == false) || (captchaSection.controls.recaptcha.invalid)"
                    (click)="canSubmit()">
                    {{'common.text_software_request_form_submit_lable'|cxTranslate}}
                    <img class = "hover-img" src="/icons/link-grey.svg" [width]="20">
                  </button>
                </div>
              </section>
            </div>
          </div>
        }
